import React, { useState } from 'react';
import RValueCoverage from './RValueCoverage';

/**
 * AtticWallToggle — Iter18 R2 §1.5.1 slice E.5
 * ---------------------------------------------------------------------------
 * Segmented Attic/Wall toggle wrapping two RValueCoverage grids for ALL
 * blow categories (fiberglass, cellulose, mineral wool) per Q10 answer
 * 2026-07-17.
 *
 * 06-25 stakeholder quote: "it should be the same across the board for all
 * blow categories anyway to keep it consistent."
 *
 * Persists as two Record<R, number|null> maps: coverage_rvalues_attic and
 * coverage_rvalues_wall. The parent (ItemCoveragePanel) merges the diff
 * into the item record on each change.
 */
export default function AtticWallToggle({ atticValues, wallValues, onChange }) {
  const [side, setSide] = useState('attic');

  const handleChange = (nextValues) => {
    if (side === 'attic') {
      onChange({ attic: nextValues, wall: wallValues || {} });
    } else {
      onChange({ attic: atticValues || {}, wall: nextValues });
    }
  };

  const Seg = ({ id, label }) => {
    const active = side === id;
    return (
      <button
        type="button"
        onClick={() => setSide(id)}
        className="px-3 py-1 text-xs font-medium rounded"
        style={{
          backgroundColor: active ? 'var(--color-action-primary)' : 'transparent',
          color: active ? 'var(--color-action-primary-text)' : 'var(--color-text-default)',
          border: `1px solid ${active ? 'var(--color-action-primary)' : 'var(--color-border)'}`,
        }}
        aria-pressed={active}
      >
        {label}
      </button>
    );
  };

  return (
    <div className="space-y-3">
      <div
        className="inline-flex rounded overflow-hidden gap-0"
        role="tablist"
        aria-label="Coverage application"
      >
        <Seg id="attic" label="Attic" />
        <Seg id="wall" label="Wall" />
      </div>

      <RValueCoverage
        values={side === 'attic' ? atticValues : wallValues}
        onChange={handleChange}
      />
    </div>
  );
}
